"use client";

import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  IconButton,
  useTheme,
} from "@mui/material";
import { tokens } from "../../../theme";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import pattern2 from "../assets/pattern2.svg";

const packages = [
  {
    name: "MUZUKURU X",
    price: "$499.00",
    earning: "$49.90",
  },
  {
    name: "MUZUKURU PRO",
    price: "$699.00",
    earning: "$69.90",
  },
  {
    name: "MUZUKURU LUX",
    price: "$1,200.00",
    earning: "$129.90",
  },
];

export default function TransparentEarnings() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        "&::before": {
          backgroundPosition: "50% 120%",
          backgroundSize: "800px",
          opacity: 0.14,
          backgroundImage: `url(${pattern2})`,
        },
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            fontSize: { xs: "1.75rem", md: "2.2rem" },
            mb: 1.5,
            color: "#3E2723",
            fontWeight: 800,
          }}
        >
          Transparent Earnings
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            color: "#5D4037",
            mb: 5,
            fontSize: "1.05rem",
          }}
        >
          Know exactly what you earn per package.
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
            gap: 3,
          }}
        >
          {packages.map((pkg) => (
            <Card
              key={pkg.name}
              sx={{
                textAlign: "center",
                border: "1px solid #724E41",
                boxShadow: "0",
                borderRadius: "24px",
              }}
            >
              <CardContent sx={{ py: 4 }}>
                <Typography
                  variant="overline"
                  sx={{
                    color: colors.primary[700],
                    fontWeight: 700,
                    letterSpacing: 1.5,
                    fontSize: "0.75rem",
                  }}
                >
                  {pkg.name}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    color: "#724E41",
                    mt: 1,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "1.9rem" },
                  }}
                >
                  {pkg.price}
                </Typography>
                <IconButton sx={{ backgroundColor: "#FFF8F2", mb: 2 }}>
                  {" "}
                  <ArrowDownwardIcon
                    sx={{
                      color: "#8D6E63",
                      fontSize: 28,
                    }}
                  />
                </IconButton>

                <Typography
                  variant="body2"
                  sx={{ color: colors.primary[700], mb: 0.5, fontSize: "0.85rem" }}
                >
                  You Earn
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: "#724E41",
                    fontSize: { xs: "1.3rem", md: "1.5rem" },
                  }}
                >
                  {pkg.earning}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
